module.exports = __webpack_public_path__ + "img/nav-exit.d67890c3.svg";